export default __webpack_public_path__ + "static/media/web-mic-icon-w.8c32d8ff.svg";